import { createContext, useCallback, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Market from '../entities/market.entity';

interface MarketContextProps {
  market: Market | null;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setMarket: React.Dispatch<React.SetStateAction<Market | null>>;
  handleSelectMarket: (newMarket: Market) => void;
  handleUnselectMarket: () => void;
}

export const MarketContext = createContext<MarketContextProps>({} as MarketContextProps);

export const useMarketContext = () => useContext(MarketContext);

export const MarketProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [market, setMarket] = useState<Market | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSelectMarket = useCallback(
    (newMarket: Market) => {
      setMarket(newMarket);
      navigate(`/markets/${newMarket.id}`);
    },
    [navigate]
  );

  const handleUnselectMarket = useCallback(() => {
    setMarket(null);
    navigate('/markets');
  }, [navigate]);

  return (
    <MarketContext.Provider
      value={{ market, loading, setMarket, setLoading, handleSelectMarket, handleUnselectMarket }}
    >
      {children}
    </MarketContext.Provider>
  );
};
